import gql from 'graphql-tag';
import useQuery from '../useQuery';
import { insightFieldsFragment, insightsPaginationFragment } from '../../fragments/insight';
import { INSIGHT_STATUSES } from '../../../constants/constants';
import { tagFieldsFragment } from '../../fragments/tag';
import { personFieldsFragment } from '../../fragments/person';

export const insightsListQuery = gql`
    query InsightsList($params: InsightsFilterInput!, $withTags: Boolean!, $withAuthors: Boolean!) {
        insights(params: $params) {
            results {
                ...insightFields
                tags @include(if: $withTags) {
                    ...tagFields
                }
                authors @include(if: $withAuthors) {
                    ...personFields
                }
                next {
                    ...insightFields
                }
                previous {
                    ...insightFields
                }
                original {
                    ...insightFields
                }
            }
            ...insightsPagination
        }
    }
    ${insightFieldsFragment}
    ${insightsPaginationFragment}
    ${tagFieldsFragment}
    ${personFieldsFragment}
`;

const defaultOrder = [{ order: 'date', orderDirection: 'DESC' }];

const useGetInsights = ({ params: paramsInput, withTags = false, withAuthors = false, ...options }) => {
    const { version, order, status: statusOverride } = paramsInput;
    const params = {
        ...paramsInput,
        status: statusOverride || INSIGHT_STATUSES.join(','),
        version: version || false,
        order: order || defaultOrder
    };

    return useQuery(insightsListQuery, {
        variables: { params, withTags, withAuthors },
        ...options
    });
};

export default useGetInsights;
